import { createMapLayerDockStore } from './map-layer-dock-state.js';
import { MapLayerDockController } from './map-layer-dock-controller.js';
import { MapLayerDockService } from './map-layer-dock-service.js';

/** Creates and wires together the store, service, and controller for the map layer dock. */
export function initMapLayerDock() {
  const store = createMapLayerDockStore();
  const service = new MapLayerDockService(store);
  const controller = new MapLayerDockController(store, service);
  return { store, service, controller };
}
